import { Close, Quiz, Visibility } from '@mui/icons-material';
import { Alert, Button, Grid, IconButton, TableCell, Tooltip, Typography } from '@mui/material';
import List from "components/UI/List";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { IAssessmentForListing, IWorkshopFeature } from 'models/EmployeeWorkshopAssessment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { handleError } from 'helpers/utils';
import { IChartView } from 'models/app';
import { Attendance_Percentage_ByEmployee, BASE_URL } from 'constants/api';
import { CHARTS } from 'constants/enums';
import { QueryClient } from 'react-query';
import { getUserData } from 'helpers';
import { useTranslation } from 'react-i18next';
import ChartView from 'components/UI/ChartView/ChartView';
import axiosInstance from 'helpers/axiosInstance';
import { getWorkshopAssessments, WorkshopAssessmentsCells } from 'framework/workshopAssessments';
import { IWorkshopAssessments } from 'models/workshopAssessments';
import { useAlert } from 'contexts/alertContext';
import { Link } from "react-router-dom";
import { EmployeeWorkshopAssessmentsCells, getEmployeeWorkshopAssessment } from 'framework/employeeWorkshopAssessment';
import { EmployeeWorkshopEvaluationCells, getEmployeeWorkshopEvaluation } from 'framework/employeeWorkshopEvaluation';
import { IWorkshopEvaluation } from 'models/workshopEvaluation';
import { IEvaluationForListing } from 'models/EmployeeWorkshopEvaluation';
import { saveAs } from 'file-saver';
import { ISSRSRequestPayload } from 'models/workshop';
import { getSSRSReport } from 'framework/workshops';
import { getCompanyById } from 'framework/company';
import { LocalStorage } from 'enums/localStorage';
import { IProfile } from 'models/company';
import { getEnrollment } from 'framework/enrollment';


interface Props {
  feature: IWorkshopFeature;
  workshopId: string,
  companyId?: string;
  enrollmentId?: string;
  eligibleForCertificate?: boolean;
  workshopTitle?: string;
  onClose: () => void;
};



const SelectedFeature: React.FC<Props> = ({ workshopId, feature, onClose, companyId, enrollmentId, eligibleForCertificate, workshopTitle }) => {
  // alert(feature.title)
  const [workshopAssessments, setWorkshopAssessments] = useState<IAssessmentForListing[]>(
    [] as IAssessmentForListing[])
  const [workshopEvaluation, setWorkshopEvaluation] = useState<IEvaluationForListing[]>(
    [] as IEvaluationForListing[])

  const [isError, setIsError] = useState<boolean>(false);

  const { setAlert } = useAlert();

  const queryClient = new QueryClient();
  async function attendanceEmployee() {
    const response = await axiosInstance.get(BASE_URL + Attendance_Percentage_ByEmployee + "/" + workshopId);
    setLoading(false)
    return response.data;
  }

  const fetchWorkshopAssessments = useCallback(async () => {
    setLoading(true);
    try {
      let response: any = await queryClient.fetchQuery(
        "get workshop assessment",
        () =>
          getEmployeeWorkshopAssessment('/listforemployee?workshopId=' + workshopId)
      );
      setWorkshopAssessments(response);
      setLoading(false);
    } catch (error: any) {
      // setAlert({
      //   open: true,
      //   message: handleError(error) || "Something went wrong",
      //   type: "error",
      // });
      setLoading(false);
      setIsError(true);
    }

    // eslint-disable-next-line
  }, [queryClient, setAlert]);

  const fetchWorkshopEvaluation = useCallback(async () => {
    setLoading(true);
    try {
      let response: any = await queryClient.fetchQuery(
        "get workshop evaluation",
        () =>
          getEmployeeWorkshopEvaluation('/listforemployee?workshopId=' + workshopId)
      );
      setWorkshopEvaluation(response);
      setLoading(false);
    } catch (error: any) {
      // setAlert({
      //   open: true,
      //   message: handleError(error) || "Something went wrong",
      //   type: "error",
      // });
      setLoading(false);
      setIsError(true);
    }

    // eslint-disable-next-line
  }, [queryClient, setAlert]);

   const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      let response: any = await queryClient.fetchQuery(
        "get Workshops per provider",
        () =>
          attendanceEmployee()
      );
      setData1(response);
      setLoading(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading(false);
      setIsError(true);
    }

    // eslint-disable-next-line
  }, [queryClient, setAlert]);

  useEffect(() => {
    fetchData();
    fetchWorkshopAssessments();
    fetchWorkshopEvaluation();
  }, []);
  const [data1, setData1] = useState<any[]>([]);
  const { t, i18n } = useTranslation();
  const user = getUserData();

  const { colors: colors1 } = user;
  const profile = useMemo<IProfile | null>(() => {
    try {
      const storedProfile = localStorage.getItem(LocalStorage.PROFILE);
      if (storedProfile) {
        return JSON.parse(storedProfile) as IProfile;
      }
    } catch (error) {
      console.error('Failed to parse profile from local storage', error);
    }
    return null;
  }, []);
  const [resolvedEmployeeId, setResolvedEmployeeId] = useState<string | null>(profile?.profile?.employeeId ?? null);
  const employeeName = profile?.profile?.name || user?.user?.userName;
  const [loading, setLoading] = useState<boolean>(true);
  const [certificateLoading, setCertificateLoading] = useState<boolean>(false);
  const [certificateTemplate, setCertificateTemplate] = useState<string | null>(null);
  const [resolvingEmployee, setResolvingEmployee] = useState<boolean>(false);

  const resolveCertificateTemplate = useCallback(async () => {
    if (certificateTemplate) {
      return certificateTemplate;
    }

    let templateName = 'Certificate-NextLMS-Width';

    if (companyId) {
      try {
        const company = await getCompanyById(companyId);
        if (company?.certificateName) {
          templateName = company.certificateName;
        }
      } catch (error) {
        console.error('Failed to fetch company certificate name', error);
      }
    }

    setCertificateTemplate(templateName);
    return templateName;
  }, [certificateTemplate, companyId]);

  const ensureEmployeeId = useCallback(async () => {
    if (resolvedEmployeeId) {
      return resolvedEmployeeId;
    }

    if (!enrollmentId) {
      return null;
    }

    try {
      setResolvingEmployee(true);
      const enrollment = await getEnrollment(enrollmentId);
      const employeeIdFromEnrollment = enrollment?.employeeId || enrollment?.EmployeeId;
      if (employeeIdFromEnrollment) {
        setResolvedEmployeeId(employeeIdFromEnrollment);
        return employeeIdFromEnrollment;
      }
    } catch (error) {
      console.error('Failed to resolve employee id from enrollment', error);
    } finally {
      setResolvingEmployee(false);
    }

    return null;
  }, [enrollmentId, resolvedEmployeeId]);

  const handleDownloadCertificate = useCallback(async () => {
    if (!eligibleForCertificate) {
      return;
    }

    const employeeId = await ensureEmployeeId();

    if (!employeeId) {
      setAlert({
        open: true,
        message: t('T_missing_employee_id') || 'Missing employee identifier',
        type: 'error',
      });
      return;
    }

    try {
      setCertificateLoading(true);
      const templateName = await resolveCertificateTemplate();
      const payload: ISSRSRequestPayload = {
        Path: `/Report Project1/${templateName}`,
        SSRSParams: [
          { Name: 'workshopId', Value: workshopId },
          { Name: 'employeeid', Value: employeeId },
        ],
      };

      const blob = await getSSRSReport(payload);
      const normalizedWorkshopTitle = workshopTitle?.trim().length
        ? workshopTitle.trim().replace(/\s+/g, '_')
        : 'Certificate';
      const normalizedEmployeeIdentifier = (employeeName && employeeName.trim().length
        ? employeeName.trim()
        : employeeId
      ).replace(/\s+/g, '_');
      const fileName = `${normalizedWorkshopTitle}_${normalizedEmployeeIdentifier}.pdf`;
      saveAs(blob, fileName);

      setAlert({
        open: true,
        message: t('T_certificate_download_success'),
        type: 'success',
      });
    } catch (error: any) {
      const errorMessage = handleError(error) || t('T_certificate_download_failed');
      setAlert({
        open: true,
        message: errorMessage,
        type: 'error',
      });
    } finally {
      setCertificateLoading(false);
    }
  }, [eligibleForCertificate, ensureEmployeeId, resolveCertificateTemplate, workshopId, workshopTitle, setAlert, t]);

  useEffect(() => {
    if (!resolvedEmployeeId && enrollmentId) {
      ensureEmployeeId();
    }
  }, [resolvedEmployeeId, enrollmentId, ensureEmployeeId]);


  const chartData1: IChartView = {
    data: {
      Labels: data1.map((item: any) => item?.date),
      Values: data1.map((item: any) => Math.round(item?.attendancePercentage)),
    },
    isPercentage: true,
    label: t("T_dashboard_employee_attendance"),
    type: CHARTS.BAR,
    backgroundColor: colors1?.chartMainColor,
    borderColor: "#c3aaeb",
    Id: "attendnacePerEmployee",
  };

  const getAssessmentsCells = (row: IAssessmentForListing) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "title")
        return {
          id: "title",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.title}</Typography>
            </TableCell>
          ),
        };

      if (key === "timeToComplete")
        return {
          id: "timeToComplete",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.timeToComplete / 60}</Typography>
            </TableCell>
          ),
        };

      if (key === "type")
        return {
          id: "type",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.type}</Typography>
            </TableCell>
          ),
        };
      if (key === "numberOfQuestions")
        return {
          id: "numberOfQuestions",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.numberOfQuestions}</Typography>
            </TableCell>
          ),
        };
      if (key === "completed")
        return {
          id: "completed",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.completed ? 'Finished' : 'Pending'}</Typography>
            </TableCell>
          ),
        };
      if (key === "id" && row.showWorkshopAssessment)
        return {
          id: "id",
          element: (
            <Tooltip title={t("T_view_details") || "View Details"}>
              <Link to={`/employeeWorkshopAssessmentDetails/${row.id}`}>
                <IconButton size={"small"} color={"info"}>
                  <Visibility />
                </IconButton>
              </Link>
            </Tooltip>
          ),
        };
      else return <></>;
    });

    return cells;
  };

  const getEvalutionCells = (row: IEvaluationForListing) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "title")
        return {
          id: "title",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.title}</Typography>
            </TableCell>
          ),
        };

      if (key === "timeToComplete")
        return {
          id: "timeToComplete",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.timeToComplete}</Typography>
            </TableCell>
          ),
        };

      if (key === "type")
        return {
          id: "type",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.type}</Typography>
            </TableCell>
          ),
        };
      if (key === "numberOfQuestions")
        return {
          id: "numberOfQuestions",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.numberOfQuestions}</Typography>
            </TableCell>
          ),
        };
      if (key === "completed")
        return {
          id: "completed",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.completed ? 'Finished' : 'Pending'}</Typography>
            </TableCell>
          ),
        };
      if (key === "id" && row.showEvaluation)
        return {
          id: "id",
          element: (
            <Tooltip title={t("T_view_details") || "View Details"}>
              <Link to={`/employeeWorkshopEvaluationDetails/${row.workshopId}`}>
                <IconButton size={"small"} color={"info"}>
                  <Visibility />
                </IconButton>
              </Link>
            </Tooltip>
          ),
        };
      else return <></>;
    });

    return cells;
  };

  return (
    <>
      <Stack spacing={2} sx={{
        borderRadius: 4,
        padding: 2,
        border: 1,
        borderColor: 'divider',
        borderStyle: 'solid',
        backgroundColor: 'background.paper',
        boxShadow: 4,
        marginTop: 2
      }}>
        <Stack direction="row" alignItems={'center'} justifyContent={'space-between'}>
          <Stack direction="row" spacing={1} alignItems={'center'} justifyContent={'start'} sx={{
          }}>
            {feature.icon2}
            <Typography variant={'h6'}>{t(feature.title)}</Typography>
          </Stack>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Stack>
        <Typography variant={'body1'} sx={{ mt: 1 }}>
          {feature.title === 'T_attendance' && !loading && (
            <Grid item xs={12} sm={6}>
              <ChartView {...chartData1} />
            </Grid>
          )}
          {feature.title === 'T_tests' && (
            <Grid item xs={12} sm={6}>
              {workshopAssessments?.length > 0 && (
                <List
                  headCells={EmployeeWorkshopAssessmentsCells}
                  data={workshopAssessments}
                  getBodyCells={getAssessmentsCells}
                  getRedirectUrl={(row) => row.showWorkshopAssessment ? `/employeeWorkshopAssessmentDetails/${row.id}` : ""}
                />
              )}
            </Grid>
          )}
          {feature.title === 'T_evaluation' && (
            <Grid item xs={12} sm={6}>
              {workshopEvaluation?.length > 0 && (
                <List
                  headCells={EmployeeWorkshopEvaluationCells}
                  data={workshopEvaluation}
                  getBodyCells={getEvalutionCells}
                  getRedirectUrl={(row) => row.showEvaluation ? `/employeeWorkshopEvaluationDetails/${row.workshopId}` : ""}
                />
              )}
            </Grid>
          )}
          {feature.title === 'T_certificates' && (
            <Grid item xs={12} sm={6}>
              {eligibleForCertificate ? (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={certificateLoading || resolvingEmployee}
                  onClick={handleDownloadCertificate}
                  sx={{ textTransform: 'none' }}
                >
                  {certificateLoading || resolvingEmployee ? t('T_downloading') : t('T_download')}
                </Button>
              ) : (
                <Alert severity="info">
                  {t('T_not_eligible_for_certificate')}
                </Alert>
              )}
            </Grid>
          )}
        </Typography>
      </Stack>
    </>
  );
}

export default SelectedFeature;